import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingProductUseCasePage } from "../components/marketing/MarketingProductUseCasePage";

export const Route = createFileRoute("/use-cases/product")({
  head: () => marketingHead("/use-cases/product"),
  component: MarketingProductUseCasePage,
});
